import { useTranslation } from 'react-i18next'
import { LandingFrame } from '../features/landing/ui/LandingFrame'
import { LandingDetailHero } from '../features/landing/ui/LandingDetailHero'
import { FeaturesSection } from '../features/landing/ui/FeaturesSection'
import { AnalyticsPreviewSection } from '../features/landing/ui/AnalyticsPreviewSection'
import { PricingSection } from '../features/landing/ui/PricingSection'

export function LandingFeaturesPage() {
  const { t } = useTranslation()

  return (
    <LandingFrame>
      <LandingDetailHero
        badge={t('landing.pages.features.badge')}
        title={t('landing.pages.features.title')}
        subtitle={t('landing.pages.features.subtitle')}
        highlights={[
          t('landing.pages.features.highlights.1'),
          t('landing.pages.features.highlights.2'),
          t('landing.pages.features.highlights.3'),
        ]}
        visual={
          <div className="rounded-2xl border border-border/70 bg-card/80 p-5 shadow-[0_0_32px_var(--glow-brand)] backdrop-blur">
            <div className="mb-3 text-xs text-muted-foreground">
              {t('landing.pages.features.visualTitle')}
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
              {[72, 38, 55, 81].map((score, index) => (
                <div
                  key={`${score}-${index}`}
                  className="rounded-xl border border-border/70 bg-background/65 p-3"
                >
                  <div className="text-[11px] text-muted-foreground">
                    {t(`landing.pages.features.visualCards.${index + 1}`)}
                  </div>
                  <div className="mt-1 text-xl font-semibold text-foreground">
                    {score}%
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
      <FeaturesSection />
      <AnalyticsPreviewSection />
      <PricingSection />
    </LandingFrame>
  )
}
